export const NO_VALUE = 'NO_VALUE';
export const FALSE_VALUE = 'false';
export const TRUE_VALUE = 'true';

export enum FEATURE_FLAG {
  EXAMPLE_FEATURE_FLAG = 'EXAMPLE_FEATURE_FLAG',
  ADOBE_ANALYTICS_DISABLED = 'ADOBE_ANALYTICS_DISABLED',
  IS_SITE_DOWN_FOR_MAINTENANCE = 'IS_SITE_DOWN_FOR_MAINTENANCE',

  // ****************
  // ** SherpathAI **
  // ****************
  IS_DIRECT_CHATBOT_ISBN = 'IS_DIRECT_CHATBOT_ISBN',
  IS_CITATION_LINKS_DISABLED = 'IS_CITATION_LINKS_DISABLED',
  // When enabled, removes the isOsmosis boolean from httpStream postBody
  DISABLE_IS_OSMOSIS_BOOLEAN = 'DISABLE_IS_OSMOSIS_BOOLEAN',
  // Enables excerpt view for ebook citations that users don't own
  ENABLE_EBOOK_EXCERPT_VIEW_SHERPATH_AI = 'ENABLE_EBOOK_EXCERPT_VIEW_SHERPATH_AI',
  ENABLE_EBOOK_EXCERPT_VIEW_OSMOSIS_AI = 'ENABLE_EBOOK_EXCERPT_VIEW_OSMOSIS_AI',
  ENABLE_EBOOK_EXCERPT_VIEW_NORA = 'ENABLE_EBOOK_EXCERPT_VIEW_NORA',
  ENABLE_EBOOK_EXCERPT_VIEW_PLP = 'ENABLE_EBOOK_EXCERPT_VIEW_PLP',
  // Gates the native welcome/disclaimer modal that replaces the Pendo-delivered T&C guide.
  IS_WELCOME_DISCLAIMER_ENABLED = 'IS_WELCOME_DISCLAIMER_ENABLED',
  ENABLE_TUTOR_MODE = 'ENABLE_TUTOR_MODE',
  ENABLE_VST_EBOOK_LINK_EVENTS = 'ENABLE_VST_EBOOK_LINK_EVENTS',
  // Opens ebook citations at an exact CFI location, falling back to the page range
  ENABLE_EBOOK_CFI_LINKING = 'ENABLE_EBOOK_CFI_LINKING',
  IS_INLINE_CITATIONS_ENABLED = 'IS_INLINE_CITATIONS_ENABLED',
  // Gates instructor insights for Osmosis AI b2b instructors
  ENABLE_INSTRUCTOR_INSIGHTS_OSMOSIS_AI_B2B = 'ENABLE_INSTRUCTOR_INSIGHTS_OSMOSIS_AI_B2B',
}

export const AB_TEST = 'AB_TEST';

export const AB_TEST_CONFIG_MAP: Partial<Record<FEATURE_FLAG, string[]>> = {
  [FEATURE_FLAG.EXAMPLE_FEATURE_FLAG]: [
    'EXAMPLE_FLAVOR_1',
    'EXAMPLE_FLAVOR_2',
  ],
};
